import { FC, useEffect, useState } from "react";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { copyToClipboard } from "../../common/Helpers";
import { OverlayTrigger, Popover } from "react-bootstrap";

interface Props {
    value: string;
}

export const CopyButton: FC<Props> = ({ value }) => {
    const [showPopover, setShowPopover] = useState(false);

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (showPopover) {
            timer = setTimeout(() => setShowPopover(false), 1500);
        }
        return () => clearTimeout(timer);
    }, [showPopover]);

    return (
        <div className="float-end">
            <OverlayTrigger
                show={showPopover}
                placement="top"
                overlay={
                    <Popover
                        id="copy-popover"
                        style={{ margin: 0, padding: 4 }}
                    >
                        <Popover.Body
                            style={{ padding: 4, margin: 0, fontSize: 12 }}
                        >
                            Copied to clipboard!
                        </Popover.Body>
                    </Popover>
                }
            >
                <FontAwesomeIcon
                    icon={faClipboard}
                    className="text-success ms-2 mouseHover"
                    onClick={(event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        setShowPopover(true);
                        copyToClipboard(value);
                    }}
                />
            </OverlayTrigger>
        </div>
    );
};
